import { TableHeadersType } from '../tableHeadersType';

export const EMAILERS_HEADERS: TableHeadersType[] = [
  {
    "label": "Email Name",
    "value": "email_name",
  
  },
  {
    "label": "Subject",
    "value": "subject",
  },
  {
    "label": "Description",
    "value": "description",
  
  },
  {
    "label": "Status",
    "value": "status",
  },
  {
    "label": "ACTION",
    "value": "Edit",
  },
];

